import {
    Premium as BadgePremium,
    Featured as BadgeFeatured
} from '@zoopla-eng/zds-components/badges';
import { FC } from 'react';

export type LayoutBadgeProps = {
    type?: 'featured' | 'premium';
};

export const LayoutBadge: FC<LayoutBadgeProps> = ({ type }) => {
    switch (type) {
        case 'featured':
            return <BadgeFeatured />;
        case 'premium':
            return <BadgePremium />;
        default:
            return null;
    }
};
